import React from 'react';
import {Stack, Typography} from '@mui/material';
import Footer from "./Footer";

interface Props {
}

const Lander: React.FC<Props> = () => {
    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{height: '100vh', width: '100vw'}}
        >
            <Typography
                variant="h3"
                sx={{mb: 6, fontWeight: 600}}
            >
                Agenda
            </Typography>

            <Footer/>
        </Stack>
    );
};

export default Lander;
